const pageModal = new bootstrap.Modal(document.getElementById('pageModal'));

if (pageModal) {
    
    // Aspetto 2.5s e poi mostro la modale
    setTimeout(() => {
        pageModal.show();
    }
    , 2500);
}